var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sleepBreathe"},[_c('div',{staticClass:"eacharts"},[_c('echarts',{attrs:{"chart-id":'sleepBreathe',"chart-option":_vm.options}}),_c('div',{staticClass:"title"},[_vm._v("睡眠得分")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }